import { poseidon } from '@iden3/js-crypto';
import { newHashFromBigInt } from './hash';
export const hashElems = (e) => {
    const hashBigInt = poseidon.hash(e);
    return newHashFromBigInt(hashBigInt);
};
export const hashElemsKey = (k, e) => {
    const hashBigInt = poseidon.hash([...e, k]);
    return newHashFromBigInt(hashBigInt);
};
//# sourceMappingURL=poseidon.js.map